const IDENTIFY_EVENTS = new Set(['$identify', '$groupidentify']);
// The event's own properties win, so explicit tracking values are never overwritten.
export const enrichmentPlugin = (getEventProperties) => ({
    name: 'tiny-health-event-properties',
    type: 'enrichment',
    execute: async (event) => {
        if (IDENTIFY_EVENTS.has(event.event_type))
            return event;
        return {
            ...event,
            event_properties: { ...getEventProperties(), ...event.event_properties },
        };
    },
});
//# sourceMappingURL=enrichment-plugin.js.map